<template>
    <div :class="prefixCls">
        <ul>
            <Tree-node
                v-for="(item, i) in stateTree"
                :key="i"
                :data="item"
                visible
                :multiple="multiple"
                :show-checkbox="showCheckbox"
                :show-radio="showRadio"
                :children-key="childrenKey"
                :treeCfg="treeCfg"
                @openTreeOperation="openTreeOperation">
            </Tree-node>
            <div :class="[prefixCls + '-empty']" v-if="!stateTree.length">{{ localeEmptyText }}</div>
        </ul>
        <div v-click-outside.capture="onClickOutside"  v-if="treeCfg.showOperation" v-show="showMenu"  class="i-poptip-popper tree-o-menu" ref="treeOpMenu">
            <div class="tree-o-menu-content i-poptip-content" >
                <div class="i-poptip-arrow"></div>
                <div class="tree-o-menu-btn" v-if="treeCfg.operation&&treeCfg.operation.addChildrenNode">
                    <Button class="btn-ellipsis-h" type="ghost" @click="addChildrenNode(operationData)">添加子节点</Button>
                </div>
                <div class="tree-o-menu-btn" v-if="treeCfg.operation&&treeCfg.operation.addSiblingNode">
                    <Button class="btn-ellipsis-h" type="ghost" @click="addSiblingNode(operationData)">添加同级节点</Button>
                </div>
                <div class="tree-o-menu-btn" v-if="treeCfg.operation&&treeCfg.operation.update">
                    <Button class="btn-ellipsis-h" type="ghost" @click="updateNode(operationData)">修改</Button>
                </div>
                <div class="tree-o-menu-btn" v-if="treeCfg.operation&&treeCfg.operation.delete">
                    <Button class="btn-ellipsis-h" type="ghost" @click="deleteNode(operationData)">删除</Button>
                </div>
                <slot></slot>
            </div>
        </div>
        <Modal footer-hide style="text-align:center;" width="300" v-model="updateNodeModal" title="">
            <Input v-model="newTitle" placeholder="Enter title..."/>
            <div class="btn-tool align-center">
                <Button type="ghost"   @click="updateNodeModal=false">{{$t('com.btn.cancel')}}</Button>
                <Button type="primary"   @click="updateNodeOk">{{$t('com.btn.ok')}}</Button>
            </div>
        </Modal>
    </div>
</template>
<script>
    import {directive as clickOutside} from '@/utils/component/v-click-outside-x';
    import TreeNode from './node.vue';
    import Emitter from './emitter';
    import popper from "../../../../static/comjs/popper.min.js";

    const prefixCls = 'ivu-tree';

    export default {
        name: 'ihlpTree',
        mixins: [ Emitter ],
        components: { TreeNode },
        directives: { clickOutside },
        props: {
            treeCfg: {
                type: Object,
                default () {
                    return {isEasyData:false}
                }
            },
            data: {
                type: Array,
                default () {
                    return [];
                }
            },
            multiple: {
                type: Boolean,
                default: false
            },
            showCheckbox: {
                type: Boolean,
                default: false
            },
            showRadio: {
                type: Boolean,
                default: false
            },
            emptyText: {
                type: String
            },
            childrenKey: {
                type: String,
                default: 'children'
            },
            loadData: {
                type: Function
            },
            render: {
                type: Function
            }
        },
        data () {
            return {
                cfg:{
                    isEasyData:false,
                    id:"id",
                    pid:"pid",
                    title:"title",
                    rootId:"-1"
                },
                cacheNode:{},
                prefixCls: prefixCls,
                stateTree: this.data,
                flatState: [],
                menuLeft:0,
                menuTop:0,
                showMenu:false,
                operationData:{},
                newTitle:"",
                isInternal:false, //是否内部修改源数据
                updateNodeModal:false,
                //单选缓存
                radioCheckNodeCache:{
                    checked:false
                }
            };
        },
        watch: {
            data: {
                deep: true,
                handler () {
                    //isEasyData: 是否是简单数据结构的数据，即不是一层层的数据结构
                    // this.stateTree = this.treeCfg.isEasyData?this.setCacheNode(this.data):this.data;
                    // this.flatState = this.compileFlatState();
                    // this.rebuildTree();
                    // this.init();
                    if(!this.isInternal){
                        this.init();
                    }
                    this.isInternal=false
                }
            }
        },
        computed: {
            localeEmptyText () {
                if (typeof this.emptyText === 'undefined') {
                    return this.$t('i.tree.emptyText');
                } else {
                    return this.emptyText;
                }
            },
            treeOpMenuStyle () {
                let self=this
                let style = {
                    left:`${self.menuLeft}px`,
                    top:`${self.menuTop}px`
                };
                return style;
            },
        },
        methods: {
            init(){
                this.stateTree = this.treeCfg.isEasyData?this.setCacheNode(this.data):this.data;
                this.flatState = this.compileFlatState();
                this.rebuildTree();
            },
            //新方式，生成树的数据，还未完成
            setCacheNode(){
                let cache={};
                let root=[];
                Object.assign(this.cfg,this.treeCfg);   //配置参数
                let treeCfg=this.cfg;
                let datas=treeCfg.data||this.data; //配置数据
                let checkbox=this.show-checkbox;    //是否显示复选框
                let id=treeCfg.id; //节点唯一标识字段
                let pid=treeCfg.pid; //父节点字段
                let title=treeCfg.title;
                let rootId=treeCfg.rootId;    //根节点值
                for(var i=0;i<datas.length;i++){
                    let item=datas[i];
                    item.title=item[title];
                    //默认不勾选
                    if(checkbox&&!item.checkbox){
                        item.checkbox=false;
                    }
                    cache[item[id]]=Object.assign({},item);
                }
                
                for(var i=0;i<datas.length;i++){
                    let item=cache[datas[i][id]];
                    if(item[pid]===rootId){
                        root.push(item);
                    }else{
                        let children=cache[item[pid]]&&cache[item[pid]][this.childrenKey];
                        if(children&&children.length>0){
                            children.push(item);
                        }else if(cache[item[pid]]){
                            cache[item[pid]][this.childrenKey]=[item];
                        }else{
                            cache[item[pid]]=[item];
                        }
                    }
                }
                this.cacheNode=cache;
                return root;
            },
            //添加节点，node：节点数据，pid 节点父节点id
            addNode(node,pid){
                let pidStr=this.cfg.pid;
                let idStr=this.cfg.id;
                pid=pid||node[pidStr];
                //内部添加数据，不刷新树
                this.isInternal=true
                //查看节点是否存在,不存在则添加
                if(this.cacheNode[node[idStr]]){
                    return false;
                }else if(pid===this.cfg.rootId){
                    this.cacheNode[node[idStr]]=node;
                    this.stateTree.push(node)
                    this.data.push(this.$utils.deepCopy(node));
                    this.flatState = this.compileFlatState();
                }else{
                    this.cacheNode[node[idStr]]=node;
                    let pNode=this.cacheNode[pid];
                    if(!pNode[this.childrenKey]){
                        this.$set(pNode, this.childrenKey, [node]);
                    }else{
                        pNode[this.childrenKey].push(node);
                    }
                    //修改原始数据
                    this.data.push(this.$utils.deepCopy(node));
                    this.flatState = this.compileFlatState();
                }
            },
            //根据id删除某个节点，包括所有子节点
            removeNodeById(id){
                let self=this,
                node=this.cacheNode[id],
                pNode=this.cacheNode[node[this.cfg.pid]],
                ids=[];
                this._removeNodeById(id,ids)
                //如果删除根节点中一个，需重新赋值根节点数据
                if(node[self.cfg.pid]===this.cfg.rootId){
                    this.stateTree=this.stateTree.filter(item=>item[self.cfg.id]!=id)
                }
                //删除节点原始数据,不能直接赋值，只能一个一个删除
                this.isInternal=true
                for(let i=0;i<this.data.length;i++){
                    let item=this.data[i]
                    if(ids.indexOf(item[self.cfg.id])!=-1){
                        this.data.splice(i,1)
                    }
                }
                //删除节点数据
                if(pNode){
                    pNode[this.childrenKey]=pNode[this.childrenKey].filter(item=>item[self.cfg.id]!=id)
                }
                //删除缓存数据
                delete this.cacheNode[id]
                this.flatState = this.compileFlatState();
            },
            //删除所有子节点缓存数据
            _removeNodeById(id,ids){
                let pNode=this.cacheNode[id],
                cNodes=pNode[this.childrenKey];
                ids.push(id)
                if(cNodes&&cNodes.length>0){
                    for(let i=0;i<cNodes.length;i++){
                        let item=cNodes[i]
                        this.removeNodeById(item[this.cfg.id],ids)
                    }
                    //删除所有子节点
                    pNode[this.childrenKey]=[]
                }else{
                    delete this.cacheNode[id]
                }
            },
            updateNodeById(data,id){
                id=id||data[this.cfg.id]
                data.title=data[this.cfg.title]
                let self=this,
                    cfg=this.cfg,
                    newPid=data[cfg.pid],
                    pNewNode=this.cacheNode[newPid],
                    node=this.cacheNode[id],
                    pid=node[cfg.pid],
                    pNode=this.cacheNode[pid]
                //如果传递过来的pid与原值不一样，则是更换了父节点
                if(newPid!=undefined&&pid!=newPid){
                    //删除原父节点中的
                    pNode[this.childrenKey]=pNode[this.childrenKey].filter(item=>item[cfg.id]!=id)
                    //添加到新父节点
                    if(newPid==cfg.rootId){
                        this.stateTree.push(node)
                    }else if(pNewNode){
                        if(!pNewNode[this.childrenKey]){
                            this.$set(pNewNode, this.childrenKey, [node]);
                        }else{
                            pNewNode[this.childrenKey].push(node);
                        }
                    }
                }
                //修改缓存中其它值
                Object.assign(this.cacheNode[id],data)
                this.flatState = this.compileFlatState();
                //修改原始数据中其它值
                this.isInternal=true
                this.data.filter(item=>{
                    if(item[self.cfg.id]==id)Object.assign(item,data)
                })
            },
            getNodeById(id){
                return this.cacheNode[id];
            },
            getRootNode(){
                return this.stateTree
            },
            compileFlatState () { // so we have always a relation parent/children of each node
                let keyCounter = 0;
                let childrenKey = this.childrenKey;
                const flatTree = [];
                function flattenChildren(node, parent) {
                    node.nodeKey = keyCounter++;
                    flatTree[node.nodeKey] = { node: node, nodeKey: node.nodeKey };
                    if (typeof parent != 'undefined') {
                        flatTree[node.nodeKey].parent = parent.nodeKey;
                        flatTree[parent.nodeKey][childrenKey].push(node.nodeKey);
                    }

                    if (node[childrenKey]) {
                        flatTree[node.nodeKey][childrenKey] = [];
                        node[childrenKey].forEach(child => flattenChildren(child, node));
                    }
                }
                this.stateTree.forEach(rootNode => {
                    flattenChildren(rootNode);
                });
                return flatTree;
            },
            updateTreeUp(nodeKey){
                const parentKey = this.flatState[nodeKey].parent;
                if (typeof parentKey == 'undefined') return;

                const node = this.flatState[nodeKey].node;
                const parent = this.flatState[parentKey].node;
                if (node.checked == parent.checked && node.indeterminate == parent.indeterminate) return; // no need to update upwards

                if (node.checked == true) {
                    this.$set(parent, 'checked', parent[this.childrenKey].every(node => node.checked));
                    this.$set(parent, 'indeterminate', !parent.checked);
                } else {
                    this.$set(parent, 'checked', false);
                    this.$set(parent, 'indeterminate', parent[this.childrenKey].some(node => node.checked || node.indeterminate));
                }
                this.updateTreeUp(parentKey);
            },
            rebuildTree () { // only called when `data` prop changes
                const checkedNodes = this.getCheckedNodes();
                checkedNodes.forEach(node => {
                    this.updateTreeDown(node, {checked: true});
                    // propagate upwards
                    const parentKey = this.flatState[node.nodeKey].parent;
                    if (!parentKey && parentKey !== 0) return;
                    const parent = this.flatState[parentKey].node;
                    const childHasCheckSetter = typeof node.checked != 'undefined' && node.checked;
                    if (childHasCheckSetter && parent.checked != node.checked) {
                        this.updateTreeUp(node.nodeKey); // update tree upwards
                    }
                });
            },

            getSelectedNodes () {
                /* public API */
                return this.flatState.filter(obj => obj.node.selected).map(obj => obj.node);
            },
            getCheckedNodes () {
                /* public API */
                return this.flatState.filter(obj => obj.node.checked).map(obj => obj.node);
            },
            getIndeterminate(){
                return this.flatState.filter(obj => obj.node.indeterminate).map(obj => obj.node);
            },
            getCheckedAndInd(){
                return this.flatState.filter(obj => obj.node.indeterminate||obj.node.checked).map(obj => obj.node);
            },
            //勾选节点,有子则不勾选
            setChildrenCheckBy(id){
              let nodeCache=this.cacheNode[id]||{},nodeKey=nodeCache.nodeKey;
              if(!nodeCache)return false
              const node = this.flatState[nodeKey].node;
              if(nodeCache[this.childrenKey]&&nodeCache[this.childrenKey].length>0)return false
              this.$set(node, 'checked', true);
              this.$set(node, 'indeterminate', false);
              this.updateTreeUp(nodeKey)
            },
            updateTreeDown(node, changes = {}) {
                for (let key in changes) {
                    this.$set(node, key, changes[key]);
                }
                if (node[this.childrenKey]) {
                    node[this.childrenKey].forEach(child => {
                        this.updateTreeDown(child, changes);
                    });
                }
            },
            handleSelect (nodeKey) {
                const node = this.flatState[nodeKey].node;
                if (!this.multiple){ // reset previously selected node
                    const currentSelectedKey = this.flatState.findIndex(obj => obj.node.selected);
                    if (currentSelectedKey >= 0 && currentSelectedKey !== nodeKey) this.$set(this.flatState[currentSelectedKey].node, 'selected', false);
                }
                this.$set(node, 'selected', !node.selected);

                this.$emit('on-select-change', this.getSelectedNodes());
            },
            handleCheck({ checked, nodeKey }) {
                const node = this.flatState[nodeKey].node;
                this.$set(node, 'checked', checked);
                this.$set(node, 'indeterminate', false);

                this.updateTreeUp(nodeKey); // propagate up
                this.updateTreeDown(node, {checked, indeterminate: false}); // reset `indeterminate` when going down

                this.$emit('on-check-change', this.getCheckedNodes(),node,checked);
            },
            handleRadioCheck({ checked, nodeKey }) {
                const node = this.flatState[nodeKey].node;
                this.radioCheckNodeCache.checked=false
                this.radioCheckNodeCache=node
                this.$set(node, 'checked', checked);
                this.$set(node, 'indeterminate', false);
                this.$emit('on-check-change', this.getCheckedNodes(),node,checked);
            },
            openTreeOperation(e,data){
                 //弹出显示前事件
                if(this.treeCfg.onBeforeShowOption){
                    if(this.treeCfg.onBeforeShowOption(data)==false){
                        return false;
                    }
                }
                this.showMenu=true
                // this.$nextTick(function(){
                //     var treeOpMenuEvnt=this.$refs.treeOpMenu,
                //     h=treeOpMenuEvnt.offsetHeight,
                //     w=treeOpMenuEvnt.offsetWidth,
                //     left=e.offsetLeft,
                //     top=e.offsetTop-(h/2)+4;
                //     this.menuLeft=left+25
                //     this.menuTop=top
                //     this.operationData=data
                // })
                // let aaa=new popper.Popper(e,this.$refs.treeOpMenu)
                this.$nextTick(function(){
                    this.operationData=data
                    let p=new popper(e,this.$refs.treeOpMenu,{flipVariations:true,placement: 'bottom-end'})
                })
            },
            //添加子节点
            addChildrenNode(cNode){
                let self=this,
                cfg=self.cfg,
                pid=cNode[cfg.id],
                id=self.$utils.getuid(),
                node={};
                node[cfg.id]=id
                node[cfg.pid]=pid
                node[cfg.title]="新增子节点"
                node.title="新增子节点"
                this.addNode(node,pid)
            },
            //添加同级节点
            addSiblingNode(cNode){
                let self=this,
                cfg=self.cfg,
                pid=cNode[cfg.pid],
                id=self.$utils.getuid(),
                node={};
                node[cfg.id]=id
                node[cfg.pid]=pid
                node[cfg.title]="新增同级节点"
                node.title="新增子节点"
                this.addNode(node,pid)
            },
            updateNode(cNode){
                this.newTitle=cNode.title
                this.updateNodeModal=true
            },
            updateNodeOk(){
                this.updateNodeModal=false
                this.operationData.title=this.newTitle
                this.operationData[this.cfg.title]=this.newTitle
            },
            deleteNode(cNode){
                //暂时先不做
                this.removeNodeById(cNode[this.cfg.id])
            },
            onClickOutside(){
                this.showMenu=false
            }
            
        },
        created(){
            // this.flatState = this.compileFlatState();
            // this.rebuildTree();
            this.init()
        },
        mounted () {
            this.$on('on-radio-check', this.handleRadioCheck);
            this.$on('on-check', this.handleCheck);
            this.$on('on-selected', this.handleSelect);
            this.$on('toggle-expand', node => this.$emit('on-toggle-expand', node));
        }
    };
</script>



// WEBPACK FOOTER //
// src/components/common/tree/tree.vue